import { useState } from "react";
import { YoutubeLiveDto } from "../../../../api/youtube-live";
import {
  YoutubeLiveWrapper,
  YoutubeLiveButton,
  YouTubeLiveListWrapper,
  YoutubeLiveItem,
} from "./styles/youtube-live.style";
import { openNewWindow } from "../../../../utils/common";

const YoutubeLive = ({ list }: { list: YoutubeLiveDto[] }) => {
  const [listOpen, setListOpen] = useState<boolean>(true);

  return (
    <YoutubeLiveWrapper>
      <YoutubeLiveButton onClick={() => setListOpen(!listOpen)}>
        <img src="/image-web/store/youtube_live.png" alt="live" />
      </YoutubeLiveButton>
      <YouTubeLiveListWrapper listOpen={listOpen}>
        {list.map((item, index) => (
          <YoutubeLiveItem
            key={index}
            onClick={() => item.link && openNewWindow(item.link)}
          >
            <img src={item.imageUrl} alt="youtuber" />
            <div className="title">LIVE</div>
          </YoutubeLiveItem>
        ))}
      </YouTubeLiveListWrapper>
    </YoutubeLiveWrapper>
  );
};

export default YoutubeLive;
